import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    chatsList: [],
    currentChatId: null,
};
const chatSlice = createSlice({
    name: 'chat',
    initialState,
    reducers: {
        setChatsList(state, action) {
            state.chatsList = action.payload;
        },
        setCurrentChatId(state, action) {
            state.currentChatId = action.payload;
        }
    }
});
export const { setChatsList, setCurrentChatId } = chatSlice.actions;
export const chatReducer = chatSlice.reducer;
